import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import Loading from './Loading.jsx';

// Wraps any route that requires an authenticated admin.
// - loading: show a spinner (don't flash the login screen)
// - no user: redirect to /login (preserving the attempted path)
// - user: render the nested routes
export default function PrivateRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loading label="Verificando sesión..." />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Outlet />;
}
